import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyCYwZxBk_rTaaGUFwSkWlY0r6xwWf8OLd4",
    authDomain: "nexo-planner.firebaseapp.com",
    projectId: "nexo-planner",
    storageBucket: "nexo-planner.firebasestorage.app",
    messagingSenderId: "375386555119",
    appId: "1:375386555119:web:88a14a04e82a44c9d0511a",
    measurementId: "G-CNXNHFEJKP"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();